import React, { useMemo } from 'react';
import { BootstrapToolTip } from '../ToolTip';
import { BsArrowBarRight } from 'react-icons/bs';
import Avatar from '@/components/Admin/reusableComponents/Avatar';
export const GoToChannel = ({ channel = {}, size, showLink = true, titleAsLink = false, styles = {} }) => {
    const title = useMemo(() => {
        return channel?.title || channel?.label;
    }, [channel]);
    const _id = useMemo(() => {
        return channel?._id || channel?.value;
    }, [channel]);
    if (!_id) {
        return <span className="badge badge-warning">No Channel</span>;
    }
    const channelUrl = `/teams/${_id}`;
    return (
        <div className="d-flex align-items-center">
            {titleAsLink ? (
                <BootstrapToolTip text="Go to channel">
                    <a
                        href={channelUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-underline"
                        style={{ textDecoration: 'underline', ...styles }}
                    >
                        {title}
                    </a>
                </BootstrapToolTip>
            ) : (
                <span>{title}</span>
            )}
            {showLink && !titleAsLink && (
                <BootstrapToolTip text="Go to channel">
                    <a href={channelUrl} target="_blank" rel="noreferrer" className="ml-2">
                        <BsArrowBarRight size={size || 24} className="text-primary" />
                    </a>
                </BootstrapToolTip>
            )}
        </div>
    );
};

export const GoToTeamSettings = ({ team = {}, size, showAvatar = false, showLink = false, tab = '' }) => {
    const name = useMemo(() => {
        return team?.name || team?.label;
    }, [team]);

    const _id = useMemo(() => {
        return team?._id || team?.value;
    }, [team]);
    if (!_id) {
        return <span className="badge badge-warning">No team</span>;
    }
    return (
        <div className="d-flex align-items-center flex-row">
            {showAvatar && (
                <div className="mr-2">
                    <Avatar item={team} />
                </div>
            )}
            {name}
            {showLink && (
                <BootstrapToolTip text={`Go to team ${tab}`}>
                    <a href={`/teams/${_id}/settings#/${tab}`} target="_blank" rel="noreferrer">
                        <BsArrowBarRight size={size || 24} className="text-primary ml-2" />
                    </a>
                </BootstrapToolTip>
            )}
        </div>
    );
};
